import { render, staticRenderFns } from "./ActionPremiumSurveyEnd.vue?vue&type=template&id=2732bbd4&scoped=true&"
import script from "./ActionPremiumSurveyEnd.vue?vue&type=script&lang=js&"
export * from "./ActionPremiumSurveyEnd.vue?vue&type=script&lang=js&"
import style0 from "./ActionPremiumSurveyEnd.vue?vue&type=style&index=0&id=2732bbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732bbd4",
  null
  
)

export default component.exports